<div class="card">
  <div class="card-header pb-0">Risk and Diversification</div>
  <div class="card-sub-header">
    <span>Portfolio:</span> {{ subHeader.portfolio }}
  </div>
  <div class="card-sub-header"><span>Type:</span> {{ subHeader.type }}</div>
  <div class="card-body pt-0">
    @if (loaded()) {
      <highcharts-chart
        [options]="chartOptions"
        [constructorType]="chartConstructor"
        style="width: 100%; height: auto; display: block"
      ></highcharts-chart>
    }
  </div>
</div>
